<div class="print-container">
    <h1 class="page-label">Carton Audit - Enter Carton Info</h1>
    <h4 class="page-label">Selected Service: {{ serviceInstance?.name }}</h4>
</div>

<div class="tab-pane">

    <div class="print-container">
        <div class="row">
            <div class="col-sm-3" style="text-align:right">
                <label class="input-label" for="cartonId">Carton ID / Barcode:</label>
            </div>
            <div class="col-sm-6">
                <input id="cartonId" [(ngModel)]="cartonId" class="form-control" type="text" [readonly]="isUiDisabled"
                    [disabled]="isUiDisabled" (keyup.enter)="onSubmit()" />
            </div>
        </div>
    </div>
</div>



<div class="print-container">
    <div class="row">
        <button (click)="onSubmit()" class="submit btn btn-primary col-sm-3" [disabled]="isUiDisabled">Submit</button>
    </div>
</div>

<!-- Progress Dialog -->
<ef-simple-indefinite-progress-dialog></ef-simple-indefinite-progress-dialog>

<!-- Error Dialog -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>